import script from "./CookiePolicyView.vue?vue&type=script&lang=js"
export * from "./CookiePolicyView.vue?vue&type=script&lang=js"

import "./CookiePolicyView.vue?vue&type=style&index=0&id=0ccde8e8&lang=scss"

const __exports__ = script;

export default __exports__